module.exports = __webpack_public_path__ + "static/media/go-west.061ac517.png";